import { __awaiter } from "tslib";
import React, { useEffect, useState } from 'react';
import { default as getCookie } from "@pb/utils/getCookie";
import { default as request } from "@pb/utils/request";
import constants from '../../constants';
import { errorHandler, mapRecommendationsToCarousel, attachColorSwatchListeners, getStyleWithDefaultsForVariant, } from '../../helpers';
import { CarouselV1 as Carousel } from '../Carousel';
const StyleWithContainer = ({ className, praConfiguration, carouseltitle, articleid, pralocale, stylewith, textnext, textprev, onCarouselFinish, textpriorprice, breakpoint, carouselHeadingClassName, }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [showCarousel, setShowCarousel] = useState(false);
    const [modelInfo, setModelInfo] = useState('');
    const [originSource, setOriginSource] = useState('');
    const [finalProducts, setProducts] = useState([]);
    const [currentArticleId, setCurrentArticleId] = useState(articleid || null);
    const [defaultList, setDefaultList] = useState(stylewith || null);
    const [articlesPerVariant, setArticlesPerVariant] = useState([]);
    const [trackedStyleWithArticles, setTrackedStyleWithArticles] = useState(undefined);
    const afterFetch = ({ articles, origin, info }) => {
        if (articles === null || articles === void 0 ? void 0 : articles.length) {
            const updatedArticlesPerVariant = articlesPerVariant;
            updatedArticlesPerVariant.push({
                article: currentArticleId,
                articles,
                origin,
                info,
            });
            setArticlesPerVariant(updatedArticlesPerVariant);
            const finalSet = mapRecommendationsToCarousel(Object.assign({ articles,
                praConfiguration }, (textpriorprice && { priorPriceLabel: textpriorprice })));
            if (finalSet.length > 0) {
                setModelInfo(info || '');
                setOriginSource(origin || '');
                setProducts(finalSet);
                setShowCarousel(true);
            }
        }
    };
    const fetchRecommendations = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            const locale = getCookie('HMCORP_locale');
            const domain = window.location.origin;
            const timeout = constants.API.TIMEOUT;
            const targetMarket = locale && locale.split('_')[1];
            if (!targetMarket) {
                throw new Error('Unable to get market.');
            }
            if (!currentArticleId) {
                throw new Error('No valid article provided.');
            }
            const path = (_a = praConfiguration === null || praConfiguration === void 0 ? void 0 : praConfiguration.API) === null || _a === void 0 ? void 0 : _a.PATH.replace(/\{locale\}/, pralocale || '');
            const queryParams = `?id=${defaultList === null || defaultList === void 0 ? void 0 : defaultList.split(',').join('&id=')}`;
            const constructedURL = `${domain}${path}${queryParams}`;
            const { data } = yield request.get(constructedURL, { timeout });
            afterFetch(data);
        }
        catch (error) {
            setShowCarousel(false);
            errorHandler(error);
        }
        finally {
            if (onCarouselFinish) {
                onCarouselFinish();
            }
            setIsLoading(false);
        }
    });
    useEffect(() => {
        if (articlesPerVariant.length) {
            const articles = articlesPerVariant.find(({ article }) => article === currentArticleId);
            if (articles) {
                afterFetch(articles);
            }
            else {
                fetchRecommendations();
            }
        }
        else {
            fetchRecommendations();
        }
    }, [defaultList]);
    useEffect(() => {
        const listOfArticles = getStyleWithDefaultsForVariant(currentArticleId);
        setDefaultList(listOfArticles);
    }, [currentArticleId]);
    useEffect(() => {
        attachColorSwatchListeners(setCurrentArticleId);
    }, []);
    if (!showCarousel || !finalProducts.length) {
        return null;
    }
    return (React.createElement(Carousel, { isLoading: isLoading, className: className, finalProducts: finalProducts, praConfiguration: praConfiguration, modelInfo: modelInfo, origin: originSource, carouselTitle: carouseltitle, showDotsWithArrows: false, textNext: textnext, textPrev: textprev, isInfinite: true, articleId: currentArticleId, trackedArticles: trackedStyleWithArticles, setTrackedArticles: (articles) => {
            setTrackedStyleWithArticles(articles);
        }, breakpoint: breakpoint, carouselHeadingClassName: carouselHeadingClassName }));
};
export default StyleWithContainer;
//# sourceMappingURL=StyleWithContainerV1.js.map